var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.company.is_freemium == 1)?_c('freemium-locked-alert'):_vm._e(),_c('labour-report')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }